import PropTypes from 'prop-types'
import { idPropType } from '../common/id-prop-type'

export const objectGroupObjectsPropType = PropTypes.shape({
    objectGroupId: idPropType,
    objectGroupObjectId: idPropType,
    objectId: idPropType
})
